/**
 * 优特商城子路由
 * 路径均为相对路径，根路由会以 /shop 为前缀挂载
 */

export const shopRoutes = [
  {
    path: 'main',
    name: 'ShopMain',
    component: () => import('@/modules/shop/views/main/index.vue'),
    meta: { title: '优特商城' }
  },
  {
    path: 'quote',
    name: 'ShopQuote',
    component: () => import('@/modules/shop/views/quote/index.vue'),
    meta: { title: '报价系统' }
  },
  {
    path: 'cart',
    name: 'ShopCart',
    component: () => import('@/modules/shop/views/cart/index.vue'),
    meta: { title: '采购车' }
  },
  {
    path: 'order',
    name: 'ShopOrder',
    component: () => import('@/modules/shop/views/order/index.vue'),
    meta: { title: '订单' }
  }
]

export default shopRoutes